import { actions as segmentioActions } from '@saucelabs/sl-util-segmentio';

const PerformanceTab = 'Performance Tab';

export const PERFORMANCE_EVENTS = Object.freeze({
  CHANGE_URL: `${PerformanceTab} Change URL`,
  HISTORY_OPEN: `${PerformanceTab} Open History`,
  OPEN_FILMSTRIP_METRICS: `${PerformanceTab} Open FilmStrip Metrics`,
  PERFORMANCE_REPORT_OPEN: `${PerformanceTab} Open Performance Report`,
});

export const trackEvent = (event) => segmentioActions.recordTrack(event);

export default trackEvent;
